export default {
    title: 'Paññã Resume Score',
    jdContent1: `Paññã AI-powered platform analyzes the job description and identifies important keywords and skills missing from your resume.`,
    jdContent2: `Update your resume with keywords and get more interviews.`,
}